import { useFilterReferralSettingContext } from "./filter-referral-setting.context";

export function FilterReferralSetting() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterReferralSettingContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}